'use client';

var _excluded = ["id", "title", "description", "action"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { AlertCircle, CheckCircle2, Loader } from 'lucide-react';
import React from 'react';
import { cn } from "../lib/utils";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "./toast";
import { useToast } from "./use-toast";
export function Toaster() {
  var _useToast = useToast(),
    toasts = _useToast.toasts;
  return /*#__PURE__*/React.createElement(ToastProvider, null, toasts.map(function (_ref) {
    var id = _ref.id,
      title = _ref.title,
      description = _ref.description,
      action = _ref.action,
      props = _objectWithoutProperties(_ref, _excluded);
    var variant = props.variant;
    return /*#__PURE__*/React.createElement(Toast, _extends({
      key: id
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row w-full"
    }, variant === 'success' && /*#__PURE__*/React.createElement(CheckCircle2, {
      className: 'stroke-slime-600'
    }), variant === 'error' && /*#__PURE__*/React.createElement(AlertCircle, {
      className: 'stroke-red-600 dark:stroke-red-400'
    }), variant === 'loading' && /*#__PURE__*/React.createElement(Loader, {
      className: "animate-spin stroke-yellow-600"
    }), /*#__PURE__*/React.createElement("div", {
      className: "grid gap-1 ml-3 flex-1 min-w-0"
    }, title && /*#__PURE__*/React.createElement(ToastTitle, {
      className: cn({
        'text-slime-700 dark:text-gray-100': variant === 'success',
        'text-red-700 dark:text-gray-100': variant === 'error',
        'text-yellow-700 dark:text-gray-100': variant === 'loading'
      })
    }, title), description && /*#__PURE__*/React.createElement(ToastDescription, {
      className: cn({
        'text-slime-600 dark:text-gray-400': variant === 'success',
        'text-red-600 dark:text-gray-400': variant === 'error',
        'text-yellow-600 dark:text-gray-400': variant === 'loading'
      }, 'opacity-100')
    }, description)), action), /*#__PURE__*/React.createElement(ToastClose, null));
  }), /*#__PURE__*/React.createElement(ToastViewport, null));
}